$(document).ready(function () {
    $('.movies_cards__card').on('click', function (e) {
        e.preventDefault()

        let target = $(this).data('target')
        $(target).show()

        $('.close').on('click', function (){
            $(target).hide()
        })

        $(window).on('click', function (e){
            if (e.target.className === 'modal') {
                $(target).hide()
            }
        })
    })
})
